<template>
  <div class="container-fluid m-0 p-0">
    <div class="row text-left bg-light border-bottom py-1 d-flex justify-content-between">
      <div class="col-auto">
        <div class="form-inline">
          <div class="form-group">
            <label for="CrewCovidVaccinated" class="form-control-lg font-weight-bold pl-0">Crew Covid Vaccinated </label>
            <select id="CrewCovidVaccinated" class="form-control form-control-sm" v-model="activeRoutes" @change="changeRoute">
              <option v-for="covidRoute in covidRoutes"
                      :key="covidRoute"
                      :value="covidRoute"
                      :title="covidRoute"
              >{{ covidRoute }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-auto py-2">
        <button class="btn btn-xs btn-outline-secondary px-2 mr-1" title="Go to Previous Page"
                @click="goBack"
        >
          <span class="fas fa-backward"></span>
          Go Back
        </button>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import {vueAppMixin} from '../../mixins/vueAppMixin';

export default {
  name: 'CovidVaccinatedCrewList',
  mixins: [vueAppMixin],
  data() {
    return {
      covidRoutes: ['all','onboard','standby'],
      activeRoutes: 'all'
    }
  },
  methods: {
    changeRoute(){
      this.$router.push({path:'/reports/covid/' + this.activeRoutes})
    }
  }
};
</script>

<style scoped>

</style>
